<template>
  <b-modal
    id="courses-modal"
    size="xl"
    hide-footer
    body-class="d-flex flex-column bg-light"
    dialog-class="align-items-stretch px-md-3"
    header-class="b-sidebar-header bg-portal-primary p-3"
    centered
    @show="selectedFilter = false"
  >
    <template #modal-header="{ hide }">
      <div class="row flex-grow-1 align-items-center">
        <div class="d-flex col">
            <span class="fs-5 fw-bolder text-white">
              {{ headerText }}
            </span>
        </div>
        <div class="d-flex ms-auto col-auto">
          <button class="btn bg-transparent border-0 p-1 btn-secondary" @click="hide">
            <b-icon icon="x" font-scale="2"></b-icon>
          </button>
        </div>
      </div>
    </template>

    <b-overlay :show="isLoading" class="flex-grow-1">
      <div class="d-flex flex-wrap mb-4">
        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
          <b-form-radio-group
            id="radio-filter-type"
            v-model="selectedFilter"
            :options="filterType"
            :aria-describedby="ariaDescribedby"
            name="filter-type-options"
          ></b-form-radio-group>
        </b-form-group>

        <span role="button" id="tooltip-target-1">
          <b-icon icon="info-circle-fill" class="text-muted" />
        </span>
        <b-tooltip target="tooltip-target-1" triggers="hover"
          >{{ translations[12202] }}
        </b-tooltip>
      </div>

      <b-overlay :z-index="1021" :opacity="0.8" class="px-0 mb-0 container-fluid" wrap-tag="ul">
        <course-item
          v-for="(course, index) of courses"
          :key="course.id"
          :course="course"
          :positionInArray="setPositionInArray(index + 1)"
          @handle-click="handleCourseLink(course)"
        />
      </b-overlay>

      <div class="row py-3 m-0">
        <limit-offset
          :jobsCount="coursesTotal"
          @set-limit="setLimit"
          :currentLimit="1"
          class="col-auto ms-auto me-1 p-0"
        />

        <pagination-nav
          :jobs-count="coursesTotal"
          :current-page="currentPage"
          :limit-per-page="limitPerPage"
          @handle-pagination="handlePagination"
          class="col-auto p-0"
        />
      </div>
    </b-overlay>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';

import { CoursesModule } from '@/store/modules/courses/courses';
// import courseModalStore from '@/store/modules/courses/courseModal';

import { ICourse } from '@/types/courses/Courses';
import { AppModule } from '@/store/modules/app';
import { openCourse } from '@/sections/courses/search';
import Limit from '@/components/Core/Limit.vue';
import Pagination from '@/components/Core/Pagination.vue';
import CourseItem from '@/components/Courses/CourseItem.vue';

@Component({
  components: {
    'pagination-nav': Pagination,
    'limit-offset': Limit,
    'course-item': CourseItem,
  },
})
export default class ModalCourses extends Vue {
  selectedFilter = false;

  // get selectedFilter() {
  //   return !!CoursesModule.avgs_filter;
  // }
  //
  // set selectedFilter(value: any) {
  //   CoursesModule.SET_AVGS_FILTER(Number(value));
  // }

  get translations() {
    return AppModule.translation;
  }

  get storeSid() {
    return AppModule.sid;
  }

  get isLoading() {
    return CoursesModule.isLoading;
  }

  get filterType() {
    return [
      { text: this.translations[12181], value: false },
      { text: this.translations[12182], value: true },
    ];
  }

  get headerText() {
    return this.translations[12180].replace('%s', CoursesModule.professionName);
  }

  get courses() {
    return CoursesModule.courses;
  }

  get coursesForModal() {
    return CoursesModule.coursesForModal;
  }

  get coursesTotal() {
    return CoursesModule.coursesCount;
  }

  get limitPerPage() {
    return CoursesModule.limitPerPage;
  }

  get currentPage() {
    return CoursesModule.currentPage;
  }

  @Watch('selectedFilter')
  async onFilterChange(val: boolean) {
    if (val) {
      await this.setAvgsFilter(1);
    } else {
      await this.setAvgsFilter(0);
    }
  }

  async setAvgsFilter(value: number) {
    CoursesModule.SET_AVGS_FILTER(value);
    CoursesModule.SET_CURRENT_PAGE();
    await CoursesModule.FETCH_COURSES_LIST(this.storeSid);
  }

  async setLimit(limit: number) {
    CoursesModule.SET_LIMIT_PER_PAGE(limit);
    CoursesModule.SET_CURRENT_PAGE();
    await CoursesModule.FETCH_COURSES_LIST(this.storeSid);
  }

  async handlePagination(page: number) {
    CoursesModule.SET_CURRENT_PAGE(page);
    await CoursesModule.FETCH_COURSES_LIST(this.storeSid);
  }

  setPositionInArray(count: number) {
    return (this.currentPage - 1) * this.currentPage + count;
  }

  handleCourseLink(course: ICourse) {
    openCourse(this.$root, course, this.coursesForModal);
  }
}
</script>

<style lang="scss" scoped>
.courses-modal {
  ::v-deep &__header {
    background-color: var(--global-first-color-10);
  }
}

::v-deep .tooltip-inner {
  min-width: 280px !important;
}
</style>
